import './readableRadioStyles.css'

export function getReadableRadioGroupClassName(variant = 'default') {
  if (variant === 'biosPassword') {
    return 'processing-readable-radio-group processing-readable-radio-group--bios-password'
  }

  return 'processing-readable-radio-group'
}

export function getReadableRadioButtonClassName(value, variant = 'default') {
  if (variant === 'biosPassword') {
    if (value === 'no') return 'processing-readable-radio-button processing-readable-radio-button--bios-no'
    if (value === 'yes') return 'processing-readable-radio-button processing-readable-radio-button--bios-yes'

    return 'processing-readable-radio-button'
  }

  if (value === 'passed') return 'processing-readable-radio-button processing-readable-radio-button--passed'
  if (value === 'failed') return 'processing-readable-radio-button processing-readable-radio-button--failed'
  if (value === 'na') return 'processing-readable-radio-button processing-readable-radio-button--na'

  return 'processing-readable-radio-button'
}
